import { SegmentoDTO } from "./segmento-dto";
import { BaseGuidDTO, IBaseGuidDTO } from "./dto.base";
import { CanalAtendimento, canalAtendimentoLabel } from "../models/segmento";
import { Endereco } from "../models/endereco";
import { formatMoney, moneyFormatToValue } from "../../../utils/money-formatter";

export interface ISolicitacaoCadastroClienteDTO extends IBaseGuidDTO {
  RepresentanteId: string;
  Representante: string;
  Cnpj: string;
  InscricaoMunicipal: string;
  InscricaoEstadual: string;
  Suframa: string;
  RazaoSocial: string;
  NomeFantasia: string;
  EmailContato: string;
  EmailNFe: string;
  EnderecoFaturamentoId: string;
  EnderecoCobrancaId: string;
  EnderecoDeCobrancaMesmoFaturamento: boolean;
  EnderecoFaturamento: Endereco;
  EnderecoCobranca: Endereco;
  NomeResponsavelSetorCompras: string;
  TelefoneSetorDeCompras: string;
  EmailSetorDeCompras: string;
  NomeResponsavelSetorFinanceiro: string;
  TelefoneSetorFinanceiro: string;
  EmailSetorFinanceiro: string;
  MotivoFalha: string;

  ContratoFidelidade: boolean;
  Percentual: number;
  ContratoFidelidadeGranel: boolean;
  PercentualGranel: number;

  SegmentoVarejoId: string;
  SegmentoVarejo: string;
  SegmentoGranelId: string;
  SegmentoGranel: string;
  ObservacaoCanalAtendimentoVarejo: string;
  ObservacaoCanalAtendimentoGranel: string;

  NumeroBanco: number;
  NomeBanco: string;
  Agencia: string;
  Conta: string;
  ContatoBanco: string;

  DataEnvioSolicitacao: Date;
  DataAprovacao: Date;
  Status: string;
  Tipo: TipoSolicitacao;

  ReferenciasComerciais: ReferenciaComercialDTO[];

  Anexos: string[];
  CaminhosAnexosTemp: string;

  ModalidadeDeCompra: ModalidadeCompra;
  CodigoCondicaoPagamento: string;
  DescricaoCondicaoPagamento: string;
  CondicaoPagamentoId: string;
}

export class SolicitacaoCadastroClienteDTO
  extends BaseGuidDTO
  implements ISolicitacaoCadastroClienteDTO {

  RepresentanteId: string;
  Representante: string;
  Cnpj: string;
  InscricaoMunicipal: string;
  InscricaoEstadual: string;
  Suframa: string;
  RazaoSocial: string;
  NomeFantasia: string;
  EmailContato: string;
  EmailNFe: string;
  EnderecoFaturamentoId: string;
  EnderecoCobrancaId: string;
  EnderecoDeCobrancaMesmoFaturamento: boolean;
  EnderecoFaturamento: Endereco;
  EnderecoCobranca: Endereco;
  NomeResponsavelSetorCompras: string;
  TelefoneSetorDeCompras: string;
  EmailSetorDeCompras: string;
  NomeResponsavelSetorFinanceiro: string;
  TelefoneSetorFinanceiro: string;
  EmailSetorFinanceiro: string;

  ContratoFidelidade: boolean;
  Percentual: number;
  ContratoFidelidadeGranel: boolean;
  PercentualGranel: number;

  SegmentoVarejoId: string;
  SegmentoVarejo: string;
  SegmentoGranelId: string;
  SegmentoGranel: string;

  ObservacaoCanalAtendimentoVarejo: string;
  ObservacaoCanalAtendimentoGranel: string;


  NumeroBanco: number;
  NomeBanco: string;
  Agencia: string;
  Conta: string;
  ContatoBanco: string;
  DataEnvioSolicitacao: Date;
  DataAprovacao: Date;
  Status: string;
  Tipo: TipoSolicitacao;
  LimiteSugerido: number;
  ModalidadeDeCompra: ModalidadeCompra;

  ReferenciasComerciais: ReferenciaComercialDTO[] = [];
  CodigoRegional: string;
  CodigoGerente: string;
  NomeRegional: string;
  NomeGerente: string;

  Anexos: string[];
  CaminhosAnexosTemp: string;

  MotivoFalha: string;
  CondicaoPagamentoId: string;
  CodigoCondicaoPagamento: string;
  DescricaoCondicaoPagamento: string;



  private _LimiteSugeridoFormatted: string;
  public get LimiteSugeridoFormatted(): string {
    return this._LimiteSugeridoFormatted;
  }

  public set LimiteSugeridoFormatted(v: string) {
    this._LimiteSugeridoFormatted = v;
    this.LimiteSugerido = (v && moneyFormatToValue(v)) || 0.00;
  }


  constructor(data: any = {}) {
    super(data);

    this.RepresentanteId = data.RepresentanteId;
    this.Representante = data.Representante;
    this.Cnpj = data.Cnpj;
    this.InscricaoMunicipal = data.InscricaoMunicipal;
    this.InscricaoEstadual = data.InscricaoEstadual;
    this.Suframa = data.Suframa;
    this.RazaoSocial = data.RazaoSocial;
    this.NomeFantasia = data.NomeFantasia;
    this.EmailContato = data.EmailContato;
    this.EmailNFe = data.EmailNFe;
    this.EnderecoFaturamentoId = data.EnderecoFaturamentoId;
    this.EnderecoCobrancaId = data.EnderecoCobrancaId;
    this.NomeResponsavelSetorCompras = data.NomeResponsavelSetorCompras;
    this.TelefoneSetorDeCompras = data.TelefoneSetorDeCompras;
    this.EmailSetorDeCompras = data.EmailSetorDeCompras;
    this.NomeResponsavelSetorFinanceiro = data.NomeResponsavelSetorFinanceiro;
    this.TelefoneSetorFinanceiro = data.TelefoneSetorFinanceiro;
    this.EmailSetorFinanceiro = data.EmailSetorFinanceiro;
    this.ContratoFidelidade = data.ContratoFidelidade;
    this.Percentual = data.Percentual;
    this.ContratoFidelidadeGranel = data.ContratoFidelidadeGranel;
    this.PercentualGranel = data.PercentualGranel;
    this.SegmentoVarejoSelect = (data.SegmentoVarejoId && data.SegmentoVarejo) && new SegmentoDTO({ Id: data.SegmentoVarejoId, Descricao: data.SegmentoVarejo })
    this.SegmentoVarejoId = data.SegmentoVarejoId;
    this.SegmentoVarejo = data.SegmentoVarejo;

    this.SegmentoGranelSelect = (data.SegmentoGranelId && data.SegmentoGranel) && new SegmentoDTO({ Id: data.SegmentoGranelId, Descricao: data.SegmentoGranel })
    this.SegmentoGranelId = data.SegmentoGranelId;
    this.SegmentoGranel = data.SegmentoGranel;

    this.ObservacaoCanalAtendimentoVarejo = data.ObservacaoCanalAtendimentoVarejo;
    this.ObservacaoCanalAtendimentoGranel = data.ObservacaoCanalAtendimentoGranel;
    this.NumeroBanco = data.NumeroBanco;
    this.NomeBanco = data.NomeBanco;
    this.Agencia = data.Agencia;
    this.Conta = data.Conta;
    this.ContatoBanco = data.ContatoBanco;
    this.DataEnvioSolicitacao =
      data.DataEnvioSolicitacao && new Date(data.DataEnvioSolicitacao);
    this.DataAprovacao = data.DataAprovacao && new Date(data.DataAprovacao);
    this.Status = data.Status;
    this.Tipo = data.Id ? data.Tipo : (data.Tipo && tiposSolicitacaoMap[data.Tipo]) || TipoSolicitacao.Novo;
    this.ModalidadeDeCompra = data.Id ? data.ModalidadeDeCompra : data.ModalidadeDeCompra && modalidadeCompraMap[data.ModalidadeDeCompra];
    this.LimiteSugerido = data.LimiteSugerido || 0.00;
    this.LimiteSugeridoFormatted = formatMoney(this.LimiteSugerido, true);

    this.EnderecoFaturamento = new Endereco(data.EnderecoFaturamento);
    this.EnderecoCobranca = new Endereco(data.EnderecoCobranca);
    this.ReferenciasComerciais =
      data.ReferenciasComerciais &&
      data.ReferenciasComerciais.map((x) => new ReferenciaComercialDTO(x));

    this.CodigoRegional = data.CodigoRegional;
    this.CodigoGerente = data.CodigoGerente;
    this.NomeRegional = data.NomeRegional;
    this.NomeGerente = data.NomeGerente;
    this.MotivoFalha = data.MotivoFalha;

    this.CondicaoPagamentoId = data.CondicaoPagamentoId;
    this.CodigoCondicaoPagamento = data.CodigoCondicaoPagamento;
    this.DescricaoCondicaoPagamento = data.DescricaoCondicaoPagamento;

    this.CaminhosAnexosTemp = data.CaminhosAnexosTemp;
    this.Anexos = (this.CaminhosAnexosTemp && this.CaminhosAnexosTemp.split(";")) || [];
  }

  private _SegmentoVarejoSelect: SegmentoDTO;
  public get SegmentoVarejoSelect(): SegmentoDTO {
    return this._SegmentoVarejoSelect;
  }
  public set SegmentoVarejoSelect(v: SegmentoDTO) {
    this._SegmentoVarejoSelect = v;
    this.SegmentoVarejoId = v && v.Id;
  }

  private _SegmentoGranelSelect: SegmentoDTO;
  public get SegmentoGranelSelect(): SegmentoDTO {
    return this._SegmentoGranelSelect;
  }
  public set SegmentoGranelSelect(v: SegmentoDTO) {
    this._SegmentoGranelSelect = v;
    this.SegmentoGranelId = v && v.Id;
  }

  public addAnexo(path) {
    this.Anexos.push(path);
    this.CaminhosAnexosTemp = this.Anexos.join(";");
  }
  public removerAnexo(anexo) {
    const i = this.Anexos.indexOf(anexo);
    this.Anexos.splice(i, 1);
    this.CaminhosAnexosTemp = this.Anexos.join(";");
  }
  preparaReferenciasComerciais() {
    let indexesToSplice = this.ReferenciasComerciais.map((r, i) => {
      return !r.Contato && !r.Empresa && !r.Telefone && !r.Email ? i : null;
    });
    indexesToSplice.forEach(i => {
      if (i == null) return;
      this.ReferenciasComerciais.splice(i, 1);
    });
  }
  rebuildReferencias(size: number = 3) {
    this.preparaReferenciasComerciais();
    const qtd = size - this.ReferenciasComerciais.length;
    for (let index = 0; index < qtd; index++) {
      this.ReferenciasComerciais.push(new ReferenciaComercialDTO());
    }
  }
}

export class ReferenciaComercialDTO extends BaseGuidDTO {
  Empresa: string;
  Contato: string;
  Telefone: string;
  Email: string;
  /**
   *
   */
  constructor(data: any = {}) {
    super(data);
    this.Empresa = data.Empresa;
    this.Contato = data.Contato;
    this.Telefone = data.Telefone;
    this.Email = data.Email;
  }
}

export enum TipoSolicitacao {
  Novo = 1,
  Atualizacao = 3
}
const tiposSolicitacaoMap = {};
for (var n in TipoSolicitacao) {
  if (typeof TipoSolicitacao[n] === "number")
    tiposSolicitacaoMap[n] = <any>TipoSolicitacao[n];
}

export { tiposSolicitacaoMap };


export enum ModalidadeCompra {
  Varejo = 1,
  Granel = 2
}
const modalidadeCompraMap = {};
for (var n in ModalidadeCompra) {
  if (typeof ModalidadeCompra[n] === "number")
    modalidadeCompraMap[n] = <any>ModalidadeCompra[n];
}

export { modalidadeCompraMap };